import React from "react";
import * as PropTypes from "prop-types";
import { getErrorMessage, refreshPage } from "utils";
import ErrorModal from "components/Modal/ErrorModal";

const ErrorFallbackModal = ({ error }) => (
  <ErrorModal errorMessage={getErrorMessage(error)} handleOk={refreshPage} />
);

export default ErrorFallbackModal;

ErrorFallbackModal.propTypes = {
  error: PropTypes.instanceOf(Error).isRequired,
};
